import { useMutation } from '@tanstack/react-query';
import { doc, updateDoc } from 'firebase/firestore';
import { getPaymentPathNavPatch, PaymentPathFlags } from '@usacsmideo/types';
import { db } from '../constants/firebaseModular';

interface UpdatePaymentPathNavPayload {
  patientId: string;
  flags: PaymentPathFlags;
}

/**
 * Writes which payment screens the patient may use, as FIELD PATHS on users/{patientId}
 * (CU-17tm466h657): only `navObj.<screen>.disabled` for the six payment screens, from the shared
 * getPaymentPathNavPatch rule. The rest of navObj is not sent, so a field another writer changed
 * (the server's reconcile, the console, another tab) is never reverted from a cached copy.
 *
 * ⚠️ updateDoc, NOT setDoc(..., { merge: true }): only updateDoc reads dotted keys as field paths.
 * It also fails if the doc is missing; callers check that navObj exists first.
 */
const updatePaymentPathNav = async ({ patientId, flags }: UpdatePaymentPathNavPayload) => {
  await updateDoc(doc(db, 'users', patientId), getPaymentPathNavPatch(flags));
};

export const useUpdatePaymentPathNav = () => {
  return useMutation({
    mutationFn: (payload: UpdatePaymentPathNavPayload) => updatePaymentPathNav(payload),
  });
};
